// @ts-nocheck
import React, { useEffect } from "react";
import { useQueryClient } from "react-query";
import { t } from "i18next";
import Button from "components/Button/Button";
import moment from "moment";
import "moment/dist/locale/fr";
import AsyncPostPreview from "Pages/Posts/components/PostPreview/AsyncPostPreview";

export default function PostEndStep(props) {

	let post = props.object;
	const queryClient = useQueryClient();

	useEffect(() => {
		if (!props.isActive) return;
		queryClient.resetQueries(["FullPostnDoc", post.postId()]);
		queryClient.resetQueries(["Documents", "DocumentOfPostAndType", post.postId()]);
		queryClient.resetQueries(["Posts", post.postId()]);
		queryClient.resetQueries(["RetrievePosts"]);
	}, [props.isActive, post, queryClient]);

	if (!props.isActive)
		return (false);

	function genPreviewText() {
		if (post.isDiffered() && post.isPublished())
			return (
				<div className="d-flex">
					<span title={moment(post.publishedDate()).locale(t("Code")).format(t("Events.DATE_TIME_AT_FORMAT"))}>
						{moment(post.publishedDate()).locale(t("Code")).format("[" + t("Posts.POST_DIFFERED") + "] " + t("Events.DATE_TIME_AT_FORMAT") + ".")}
					</span>
				</div>
			);
		else if (post.isPublished())
			return (t("Posts.POST_PUBLISHED"));
		else {
			if (!post.draft()) {
				return (
					<div>
						<div>{t("Posts.POST_MODERATION")}</div>
						<div>{t("Posts.POST_MODERATION_2")}</div>
					</div>
				);
			} else {
				return (
					<div>
						<div>{t("Posts.POST_DRAFTED")}</div>
						<div><Button className="btn-primary" onClick={props.dispDrafts}>{t("Commons.SHOW_DRAFTS")}</Button></div>
					</div>
				);
			}
		}
	}

	return (
		<div className="d-flex flex-column flex-md-row justify-content-between overflow-auto inner-step-cont">
			<div className="ms-2">
				{
					genPreviewText()
				}
			</div>
			<AsyncPostPreview
				id="post-preview-after-send"
				className="mt-3 mt-md-0"
				extend={false}
				isEndStep={true}
				extendImages={false}
				responsive={false}
				postId={post.postId()}
				showComments={false}
				onClose={props.onClose}
			/>
		</div>
	);
}
